//import React, { useContext } from 'react';
import { PageHeader, Page, PageContent, Heading, Box, Text } from 'grommet';

export const SustainabilityHome = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('/images/hpe-hq-front.jpg')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
                        <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                          title={<Text color="white" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>OneGW and Sustainability</Text>} 
                          subtitle={'Driving our sustainable future.'}
                          style={{ color: 'white' }}
                          size='medium'/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="small" weight="bold" margin={{ top: 'large' }}>Coming soon...</Heading>

      </PageContent>  

    </Page>
  );
};